import { render, staticRenderFns } from "./CSVItem.vue?vue&type=template&id=02dbbce8&"
import script from "./CSVItem.vue?vue&type=script&lang=js&"
export * from "./CSVItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports